import axios from 'axios';
import { environmentConfig } from '../config/environmentConfig';

export default class LeaderboardService {
    /* eslint-disable */
    static async getFantasyPoints(internalUsersData) {
        return await axios.post(`${environmentConfig.InternalDashboardHost}/get-fantasy-points`, internalUsersData);
    };
};
